import { X } from "lucide-react";

export function Modal({ open, title, children, onClose, footer }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 dark:bg-black/60 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white dark:bg-slate-900 shadow-xl border dark:border-slate-800">
        <div className="flex items-center justify-between border-b dark:border-slate-800 p-4">
          <div className="font-bold text-slate-900 dark:text-slate-100">{title}</div>
          <button
            onClick={onClose}
            className="rounded-lg p-2 hover:bg-slate-100 dark:hover:bg-slate-800"
            aria-label="Close"
          >
            <X className="h-5 w-5 text-slate-700 dark:text-slate-300" />
          </button>
        </div>

        <div className="p-4">{children}</div>

        {footer ? (
          <div className="border-t dark:border-slate-800 p-4 flex justify-end gap-2">{footer}</div>
        ) : null}
      </div>
    </div>
  );
}